import React from "react"
import Typography from "aldoo-ra/Typography"
import CMSRender from "aldoo-ra/CMS/cms-render"
import PostCard from "../../Blog/post-card"
import TextBundle from "aldoo-ra/CMS/text-bundle"

export default function LatestPostsSection() {
  const texts = TextBundle({ id: "home_latest_posts" })
  return (
    <section className="px-4 pb-20 md:pb-28">
      <div className="max-w-md sm:max-w-4xl xl:max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <Typography
            component="h2"
            variant="h1"
          >
            {texts?.section_title}
          </Typography>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6 md:gap-8">
          <CMSRender
            contentType="BlogPost"
            sort={{ "content.publish_date": -1, _id: -1 }}
            itemsPerPage={3}
            match={{
              "content.status": "published",
            }}
            renderItem={(post, index) => (
              <div className={index === 2 ? "hidden xl:block" : ""}>
                <PostCard post={post} />
              </div>
            )}
          />
        </div>
      </div>
    </section>
  )
}
